class MojoProductRecommendations extends HTMLElement {
  #observer = new IntersectionObserver(
    (entries, observer) => {
      if (!entries[0]?.isIntersecting) return;
      observer.disconnect();
      this.#load();
    },
    { rootMargin: '0px 0px 500px 0px' }
  );

  #controller = null;

  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer.disconnect();
    this.#controller?.abort();
  }

  async #load() {
    const { url, productId, sectionId, intent = 'related' } = this.dataset;
    if (!url || !productId || !sectionId || this.dataset.loading === 'true') return;

    this.dataset.loading = 'true';
    this.#controller?.abort();
    this.#controller = new AbortController();

    try {
      const requestUrl = `${url}&product_id=${encodeURIComponent(productId)}&section_id=${encodeURIComponent(sectionId)}&intent=${encodeURIComponent(intent)}`;
      const response = await fetch(requestUrl, { signal: this.#controller.signal });
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const markup = await response.text();
      const container = document.createElement('div');
      container.innerHTML = markup;
      const replacement = container.querySelector(`mojo-product-recommendations[id="${CSS.escape(this.id)}"]`);

      if (!replacement?.innerHTML.trim()) {
        this.hidden = true;
        return;
      }

      this.innerHTML = replacement.innerHTML;
      this.dataset.loaded = 'true';
      this.dataset.loading = 'false';
      this.#executeScripts();
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Mojo product recommendations:', error);
      this.hidden = true;
    }
  }

  #executeScripts() {
    this.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attribute) => {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }
}

if (!customElements.get('mojo-product-recommendations')) {
  customElements.define('mojo-product-recommendations', MojoProductRecommendations);
}
